import axios from 'axios';

const cepService = {
  methods: {
    async fetchCep(cep) {
      const api = 'https://viacep.com.br/ws';
      const url = `${api}/${cep}/json`;

      try {
        const response = await axios.get(url, { timeout: 3000 });
        const { logradouro, bairro, localidade, uf } = response.data;

        return {
          street: logradouro,
          neighborhood: bairro,
          city: localidade,
          state: uf,
        };
      } catch {
        throw new Error('Invalid CEP');
      }
    },
  },
};

export default cepService;
